module.exports = __webpack_public_path__ + "img/icon_map_62_on_101.51510027.png";